import React, { useRef, useEffect, useState, useCallback } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { Col, Container, Form, Row } from "react-bootstrap";
import "./UserRegistration.css";
import useAuth from "../../hooks/useAuth";
// import Select from 'react-select';
import { useLocation } from 'react-router-dom';
import { fetchPranthList } from './pranthService'; // Adjust path as needed
import { useNavigate } from 'react-router-dom'; // Import useNavigate

const ADD_KHAND_TO_USER = "add-level-to-user";
const REMOVE_KHAND_TO_USER = "remove-level-from-user";

const AdminAddKhandToUser = () => {
  const back = async (e) => {
    e.preventDefault();
    // setSuccess(false);
  };
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const userRef = useRef();
  const errRef = useRef();

  const { auth } = useAuth();

  const [errMsg, setErrMsg] = useState("");
  const [sucssMsg, setSucssMsg] = useState("");

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const personId = queryParams.get('person_id');
  const name = queryParams.get('name');
  const mobile = queryParams.get('mobile');
  const [error, setError] = useState(null);
  const [pranthList, setPranthList] = useState([]);
  const [selectedPranthId, setSelectedPranthId] = useState(1);
  const [arthiksakhasList, setArthiksakhasList] = useState([]);
  const [selectedArthiksakhasId, setSelectedArthiksakhasId] = useState("");
  const [khandList, setKhandList] = useState([]);
  const [selectedKhandId, setSelectedKhandId] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const KhandsOfKhandUserPerPage = 15;
  const [KhandsOfKhandUser, setKhandsOfKhandUser] = useState([]);

  useEffect(() => {
    const getPranths = async () => {
      const data = await fetchPranthList(); // Get data from the service
      setPranthList(data);                  // Set data to state
    };

    getPranths();
  }, []);

  useEffect(() => {
    fetchPranthList();
  }, []);

  useEffect(() => {
    if (selectedPranthId) {
      fetchArthiksakhaList(selectedPranthId).then((vibhags) => {
        if (vibhags.length > 0) {
          setSelectedArthiksakhasId(vibhags[0].vibhag_id);
        } else {
          setSelectedArthiksakhasId("");
          setArthiksakhasList([]);
          // setKhands([]);
          setKhandList([]);              // ✅ Add this line
          setSelectedKhandId("");        // ✅ Add this line
          // setError("No vibhags for selected pranth");
        }
      });
    }
  }, [selectedPranthId]);

  const fetchKhands = useCallback(async () => {
    if (!selectedArthiksakhasId) return;

    // setLoading(true);
    // setKhands([]);
    try {
      const res = await axiosPrivate.get(`list-khands-in-arthik-sakha?arthik_sakha_id=${selectedArthiksakhasId}`);
      const data = Array.isArray(res.data) ? res.data : [];
      setKhandList(data);
      if (data.length > 0) {
        setSelectedKhandId(data[0].khand_id); // optional default
      } else {
        setSelectedKhandId("");
      }
    } catch (err) {
      console.error("Khand fetch failed:", err);
      setError("Failed to load Khand list");
      setKhandList([]);
      setSelectedKhandId("");
    }
    // finally {
    //   setLoading(false);
    // }
  }, [axiosPrivate, selectedArthiksakhasId]);

  useEffect(() => {
    if (selectedArthiksakhasId) {
      fetchKhands();
    }
  }, [selectedArthiksakhasId]);



  const fetchArthiksakhaList = async (pranthId) => {
    try {
      const res = await axiosPrivate.get(`list-arthik-sakhas?pranth_id=${pranthId}`);
      const data = Array.isArray(res.data) ? res.data : [];
      setArthiksakhasList(data);
      return data;
    } catch (err) {
      console.error("Failed to fetch Arthiksakha", err);
      setArthiksakhasList([]);
      return [];
    }
  };

  const fetchKhandsOfKhandUser = useCallback(async () => {
    setError(null); // clear previous error
    try {
      const response = await axiosPrivate.get(`list-levels-of-user?person_id=${personId}`, {
        withCredentials: true,
      });
      setKhandsOfKhandUser(response.data);
      // setLoading(false);
    } catch (error) {
      console.error("Error fetching khands of khand user:", error);
      setError(error?.response?.data?.message?.toString() || error?.message || "No khands of khand user available.");
      // setLoading(false);
    }
  }, [axiosPrivate, personId]); // 👈 dependency added

  useEffect(() => {
    fetchKhandsOfKhandUser();
  }, [personId]);

  const AddKhandToUserSubmit = async (e) => {
    e.preventDefault();

    try {
      var data = JSON.stringify({
        level_id: selectedKhandId,
        person_id: personId,
        role: "Khand"

      });

      const response = await axiosPrivate.post(ADD_KHAND_TO_USER, data, {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      });

      showMessage('success', response?.data?.message);
      fetchKhandsOfKhandUser();
    } catch (err) {

      if (!err?.response) {
        setErrMsg("No Server Response");
      } else if (err.response?.data?.message) {
        const errorMsg = typeof err.response.data.message === 'string'
          ? err.response.data.message
          : err.response.data.message.msg || "Unknown error"; // Extract inner msg if object
        setErrMsg(errorMsg);
      } else {
        setErrMsg("Registration Failed");
      }
    }

  };


  const RemoveKhandFromUser = async (e, khandId, personId) => {
    e.preventDefault();
    try {
      const data = JSON.stringify({
        level_id: khandId,
        person_id: personId,
        role: "Khand"
      });
      console.log("data = ", data)


      const response = await axiosPrivate.post(REMOVE_KHAND_TO_USER, data, {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      });

      showMessage('success', response?.data?.message);
      fetchKhandsOfKhandUser();
    } catch (err) {
      if (!err?.response) {
        setErrMsg("No Server Response");
      } else if (err.response?.data?.message) {
        const errorMsg = typeof err.response.data.message === 'string'
          ? err.response.data.message
          : err.response.data.message?.msg || "Unknown error";
        setErrMsg(errorMsg);
      } else {
        setErrMsg("Operation Failed");
      }
    }
  };


  const showMessage = (type, message) => {
    if (type === 'error') {
      setErrMsg(message);
      setSucssMsg(""); // ensure success message is cleared
    } else if (type === 'success') {
      setSucssMsg(message);
      setErrMsg(""); // ensure error message is cleared
    }

    // Auto-hide after 10 seconds
    setTimeout(() => {
      setErrMsg("");
      setSucssMsg("");
    }, 10000); // 10000ms = 10 seconds
  };



  const indexOfLastKhandsOfKhandUser = currentPage * KhandsOfKhandUserPerPage;
  const indexOfFirstKhandsOfKhandUser = indexOfLastKhandsOfKhandUser - KhandsOfKhandUserPerPage;
  const currentKhandsOfKhandUser = KhandsOfKhandUser.slice(indexOfFirstKhandsOfKhandUser, indexOfLastKhandsOfKhandUser);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const totalPages = Math.ceil(KhandsOfKhandUser.length / KhandsOfKhandUserPerPage);

  return (
    <>
      <Container>

        <button onClick={() => navigate(-1)} className="btn btn-secondary newviewbtn"> ← Back</button>
        {/* {success ? (
          <section>
            <h1>User successfully registred !</h1>
            <div className="flexGrow">
              <button onClick={back}>Back</button>
            </div>
          </section>
        ) : ( */}


        <section className="userregbody2">

          <p
            ref={errRef}
            className={errMsg ? "errmsg" : "offscreen"}
            aria-live="assertive"
          >
            {errMsg}
          </p>

          <p
            ref={errRef}
            className={sucssMsg ? "sucssmsg" : "offscreen"}
            aria-live="assertive"
          >
            {sucssMsg}
          </p>


          <div className="wrapper wrapper2 new_arthiksakha">
            <form>
              <h3 class="arthik_head">Add new khand to <span class="colorChange">{name}</span></h3>

              <p className="arthik_head">Phone: {mobile}</p>
              <form onSubmit={AddKhandToUserSubmit}>
                {/* <Form.Label className="newformstyle">Select Pranth</Form.Label>
                <Form.Select
                  className="newselectstyle"
                  value={selectedPranthId}
                  onChange={(e) => {
                    const pranthId = e.target.value;
                    setSelectedPranthId(pranthId);

                    if (!pranthId) {
                      // Clear vibhag, jilla, and table if no Pranth selected
                      setArthiksakhasList([]);
                      setSelectedArthiksakhasId("");

                      setKhandList([]);
                      setSelectedKhandId("");

                      // setKhands([]);
                    }
                  }}
                > 
                <option value="">-- Select Pranth --</option>
                {pranthList.map((p) => (
                  <option key={p.id} value={p.id}>
                    {p.name}
                  </option>
                ))}
              </Form.Select> */}
                <Row>
                  <Col md={6}>

                    <Form.Label className="newformstyle">Select Arthiksakha</Form.Label>
                    <Form.Select
                      className="newselectstyle"
                      value={selectedArthiksakhasId}
                      onChange={(e) => {
                        const ArthiksaId = e.target.value;
                        setSelectedArthiksakhasId(ArthiksaId);

                        if (!ArthiksaId) {
                          // Clear Jilla list and selection if no Vibhag selected
                          // setJillaList([]);
                          // setSelectedJillaId("");
                          // setKhands([]); // Optional: clear table too

                          // setKhandList([]);
                          // setSelectedKhandId("");
                          // setKhands([]);
                        }
                      }}
                      disabled={!arthiksakhasList.length}
                    >
                      <option value="">-- Select Arthiksakhas --</option>
                      {Array.isArray(arthiksakhasList) &&
                        arthiksakhasList.map((v) => (
                          <option key={v.arthik_sakha_id} value={v.arthik_sakha_id}>
                            {v.arthik_sakha}
                          </option>
                        ))}
                    </Form.Select>
                  </Col>

                  <Col md={6}>

                    <Form.Label className="newformstyle">Select Khand</Form.Label>
                    <Form.Select
                      className="newselectstyle"
                      value={selectedKhandId}
                      onChange={(e) => setSelectedKhandId(e.target.value)}
                      disabled={!khandList.length}
                    >
                      <option value="">-- Select Khand --</option>
                      {khandList.map((k) => (
                        <option key={k.khand_id} value={k.khand_id}>
                          {k.khand_name}
                        </option>
                      ))}
                    </Form.Select>
                  </Col>
                </Row>




              </form>



              <button
                type="button" // Important to prevent form submit
                className="btn"
                onClick={AddKhandToUserSubmit} // Call this for "Sign Up"
                disabled={!selectedKhandId}
              >
                Submit
              </button>
            </form>

          </div>

          <br></br>
          <div className="wrapperemp2">
            {/* <button onClick={handleRedirect} type="button" className="btn btn-success ms-auto d-block top-bt">+ Create Vibhag</button> */}
            <h3>List Khands of {name}</h3>

            <div className="table-container">
              <table id="customers">
                <thead>
                  <tr>
                    <th>Khand name (Malayalam)</th>
                    <th>Khand name</th>
                    <th>Options</th>
                  </tr>
                </thead>

                <tbody>
                  {error ? (
                    <tr>
                      <td colSpan="6" className="text-danger text-center">
                        {error}
                      </td>
                    </tr>
                  ) : KhandsOfKhandUser.length === 0 ? (
                    <tr>
                      <td colSpan="6">No Data available.</td>
                    </tr>
                  ) : (
                    currentKhandsOfKhandUser.map(KhandOfKhandUser => (
                      <tr key={KhandOfKhandUser.level_id}>
                        <td>{KhandOfKhandUser.level_name}</td>
                        <td>{KhandOfKhandUser.search_tag}</td>


                        <td>
                          <button class="btn btn-danger" onClick={(e) => RemoveKhandFromUser(e, KhandOfKhandUser.level_id, KhandOfKhandUser.person_id)}>
                            Remove Khand
                          </button>

                        </td>
                      </tr>
                    ))
                  )}
                </tbody>


              </table>
            </div>

            {totalPages > 1 && (
              <div className="pagination">
                <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>Previous</button>
                {Array.from({ length: totalPages }, (_, index) => (
                  <button
                    key={index}
                    onClick={() => handlePageChange(index + 1)}
                    disabled={currentPage === index + 1}
                  >
                    {index + 1}
                  </button>
                ))}
                <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>Next</button>
              </div>
            )}
          </div>
        </section>
        {/* )} */}
      </Container >
    </>
  );
};

export default AdminAddKhandToUser;
